import { BaseModel } from './BaseModel';

export class AssessmentEvaluation extends BaseModel {
  static get entity() {
    return 'assessment_evaluation';
  }

  static get fk() {
    return 'assessment_evaluation_id';
  }

  static fields() {
    return {
      id: this.uid(),
      pass: this.attr(null),
      evaluated_user: this.attr(null),
      post_response: this.attr(null),
      single_post_response: this.attr(null),
      deleted_at: this.attr(null),
      criterion: this.attr(null),
      additional_criterion: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      update(id, body) {
        return this.put(`/assessment-evaluations/${id}`, body);
      }
    }
  };
}

export default AssessmentEvaluation;
